import { render, staticRenderFns } from "./VacationReportOverviewRelation.vue?vue&type=template&id=2371f176&"
import script from "./VacationReportOverviewRelation.vue?vue&type=script&lang=js&"
export * from "./VacationReportOverviewRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports